import Record from "slotworks/model/gameplay/records/record";

export default class WheelBonusRecord extends Record {
    public buyoutGame: boolean;
    public game: string;
    public is_complete: boolean;
    public total_base_game_win_amount: number;
    public total_bonus_games_win_amount: number;
    public spins: number;
    public total: number;
    public giftedAdditional: number;
    public remain: number;
    public totalCreditsWon: number;
}